import { Component, OnInit, ViewChild } from '@angular/core';
import organisationList from './organisations.json';
import { Organisation } from './organisations';
import { NgForm } from '@angular/forms';
import { OrganisationService } from './services/organisation.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.css']
})
export class OrganisationComponent implements OnInit {
  organisations: Organisation[] = organisationList;
  currentOrganisation = "";
  @ViewChild('organisationForm', { static: false })
  organisationForm!: NgForm;
  organis: string[] = [];
  constructor(private readonly organisationService: OrganisationService, private readonly router: Router) {
    
  }
  ngOnInit(): void {
  }
  onSubmit() {
    this.currentOrganisation = this.organisationForm.form.value.organisation;
    this.organisationService.organisationEmitter.next(this.currentOrganisation);
    this.organisationService.setLocalStorageItem("CurrentOrganisation", this.currentOrganisation);
    this.router.navigate(['/']);    
  }
}
